module.exports = {
	add:'添加角色',
	searchmsg:'请输入角色名称搜索',
	stateholder:'请选择角色状态',
	name:'角色名称',
	icon:'图标',
	auth:'权限',
	manage:'超级管理员',
	info:'角色说明',
	nameholder:'请输入角色名称',
	infoholder:'请输入角色说明',
	namemsg:'角色名称不能为空',
	setauth:'配置角色权限',
	menu:{
		title:'菜单管理',
		name:'菜单名称',
		nameholder:'请输入菜单名称',
		iconholder:'请输入菜单图标',
		namemsg:'菜单名称不能为空'
	}
}


// WEBPACK FOOTER //
// ./src/i18n/locales/zh-cn/modules/role.js